import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MessageTrackingService {
  public hasShownLimitAccessMessage = false;
}